export default __webpack_public_path__ + "static/media/claimIcon.58ae2107.svg";